import React, { useCallback, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import httpService from "../../services/http-service";
import { getAuthToken } from "../../services/auth-service";
import LoadIndicator from "devextreme-react/load-indicator";

const SupervisionRouteGuard = ({ supervisionOnly = false }) => {
  const [access, setAccess] = useState(null);
  const [retryCount, setRetryCount] = useState(0);

  const checkAccess = useCallback(async (signal) => {
    const token = getAuthToken("token");
    const domain = localStorage.getItem("pathURL");

    if (!token || !domain) {
      setAccess("unauthorized");
      return;
    }

    try {
      const response = await httpService.get(
        "/api/Account/supervision-access",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Domain: domain,
          },
          signal,
        }
      );

      if (
        response?.data?.isSuccess === true &&
        typeof response?.data?.data?.bSupervision === "boolean"
      ) {
        setAccess(response.data.data.bSupervision);
      } else {
        setAccess("error");
      }
    } catch (error) {
      if (signal.aborted) return;

      if (error?.response?.status === 401) {
        setAccess("unauthorized");
      } else if (error?.response?.status === 403) {
        setAccess("forbidden");
      } else {
        setAccess("error");
      }
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    setAccess(null);
    checkAccess(controller.signal);

    return () => controller.abort();
  }, [checkAccess, retryCount]);

  if (access === null) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f4f7fb",
      }}
    >
      <LoadIndicator
        visible={true}
        height={40}
        width={40}
      />
    </div>
  );
}

  if (access === "unauthorized") {
    return <Navigate to="/login" replace />;
  }

  if (access === "forbidden") {
    return (
      <div style={{ padding: "24px" }}>
        You do not have permission to access this application.
      </div>
    );
  }

  if (access === "error") {
    return (
      <div style={{ padding: "24px" }}>
        <p>Unable to verify access. Please try again.</p>

        <button
          type="button"
          onClick={() => setRetryCount((count) => count + 1)}
        >
          Retry
        </button>
      </div>
    );
  }

  if (supervisionOnly && access === false) {
    return <Navigate to="/home" replace />;
  }

  if (!supervisionOnly && access === true) {
    return (
      <Navigate
        to="/supervision/participants"
        replace
      />
    );
  }

  return <Outlet />;
};

export default SupervisionRouteGuard;